export enum InspirationsActionType {
	FETCH_ALL_INSPIRATIONS = 'FETCH_ALL_INSPIRATIONS',
	STORE_ALL_INSPIRATIONS = 'STORE_ALL_INSPIRATIONS',
	ERROR_ALL_INSPIRATIONS = 'ERROR_ALL_INSPIRATIONS',
	RESET_INSPIRATION_DATA = 'RESET_INSPIRATION_DATA',

	FETCH_INSPIRATION_DETAILS = 'FETCH_INSPIRATION_DETAILS',
	STORE_INSPIRATION_DETAILS = 'STORE_INSPIRATION_DETAILS',
	ERROR_INSPIRATION_DETAILS = 'ERROR_INSPIRATION_DETAILS',

	ADD_INSPIRATION = 'ADD_INSPIRATION',
	DELETE_INSPIRATION = 'DELETE_INSPIRATION',
	UPDATE_INSPIRATION_ITEM = 'UPDATE_INSPIRATION_ITEM',

	FETCH_INSPIRATION_PRODUCT_MAPPINGS = 'FETCH_INSPIRATION_PRODUCT_MAPPINGS',
	STORE_INSPIRATION_PRODUCT_MAPPINGS = 'STORE_INSPIRATION_PRODUCT_MAPPINGS',
	ERROR_INSPIRATION_PRODUCT_MAPPINGS = 'ERROR_INSPIRATION_PRODUCT_MAPPINGS',

	UPDATE_ITEM_MAPPING_INCLUSION_STATUS = 'UPDATE_ITEM_MAPPING_INCLUSION_STATUS',
	DELETE_INSPIRATION_ITEM_MAPPING = 'DELETE_INSPIRATION_ITEM_MAPPING',
	ADD_INSPIRATION_ITEM_MAPPING = 'ADD_INSPIRATION_ITEM_MAPPING',

	FETCH_SHORTLISTED_INSPIRATIONS = 'FETCH_SHORTLISTED_INSPIRATIONS',
	STORE_SHORTLISTED_INSPIRATIONS = 'STORE_SHORTLISTED_INSPIRATIONS',
	ERROR_SHORTLISTED_INSPIRATIONS = 'ERROR_SHORTLISTED_INSPIRATIONS',
	SHORTLIST_INSPIRATION = 'SHORTLIST_INSPIRATION',
	REMOVE_SHORTLISTED_INSPIRATION = 'REMOVE_SHORTLISTED_INSPIRATION'
}
